// menu-trigger.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuTriggerService {
    menuStateSubject = new BehaviorSubject<boolean>(false);
    menuState$ = this.menuStateSubject.asObservable();

    openMenu(): void {
        this.menuStateSubject.next(true);
    }

    closeMenu(): void {
        this.menuStateSubject.next(false);
    }
}
